export const rutasCotizarCatolica = [
  {
    codigo: 'SEG-PLENI-HILC',
    ruta: '/cotizar-seguro-plenisalud-hilc',
  }
];
